import { render, staticRenderFns } from "./RecordStatusSelector.vue?vue&type=template&id=2e847c0b&scoped=true&"
import script from "./RecordStatusSelector.vue?vue&type=script&lang=js&"
export * from "./RecordStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./RecordStatusSelector.vue?vue&type=style&index=0&id=2e847c0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e847c0b",
  null
  
)

export default component.exports